import axios from "axios";

const GALLERY_SECTION_API_URL = `${process.env.REACT_APP_API_URL}/roomGallery`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all footer sections
export const fetchGallerySections = async () => {
  const response = await axios.get(`${GALLERY_SECTION_API_URL}`, { headers: customHeaders });
  return response.data;
};

// Create a new Gallery section
export const addGallerySection = async (newGallerySection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.post(GALLERY_SECTION_API_URL, newGallerySection, { 
    headers:  {
  'Content-Type': 'multipart/form-data',
}
  });
  return response.data;
};

// Edit an existing Gallery section
export const updateGallerySection = async (id:string,updatedGallerySection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.put(`${GALLERY_SECTION_API_URL}/${id}`, updatedGallerySection, { 
    headers:  {
  'Content-Type': 'multipart/form-data',
}
  });
  return response.data;
};
